export default __webpack_public_path__ + "static/media/BankTransferIcon.7a19ec46.svg";